import './EntriesArchiveSlider.scss';
class EntriesArchiveSlider {
    constructor( node ) {
        this.node = node;
    }
    init() {
        let t = this;

        if( typeof JSModules['PsInit'] != 'undefined' ) {
            new JSModules['PsInit']( t.node );
        }

        let carouselWrapper = t.node.querySelector('.carousel__content');

        let boxs = t.node.querySelectorAll('.content__slide');
        let slides = t.node.querySelectorAll('.content__slide .slide__element');
        let buttonPrev = t.node.querySelector('.EntriesArchiveSlider__wrapper .wrapper__button--prev .button__content');
        let buttonNext = t.node.querySelector('.EntriesArchiveSlider__wrapper .wrapper__button--next .button__content');

        let controls = t.node.querySelectorAll('.EntriesArchiveSlider__control .control__button');

        // -- desktop box observer -- //
            let observerBox = new IntersectionObserver(
                ( entries, index ) => {
                    entries.forEach( ( entry, index ) => {

                        if( window.innerWidth > 1180 ) {

                            boxs.forEach( ( box, index ) => {
                                if( !box.hasAttribute('aria-hidden') ) {
                                    box.setAttribute('aria-hidden','true');
                                }
                            });

                            if( entry.isIntersecting ) {
                                entry.target.setAttribute('aria-hidden','false');

                                controls.forEach( ( el, index ) => {
                                    if( index == parseInt( entry.target.getAttribute('data-index') ) ) {
                                        el.setAttribute('aria-current','true');
                                    } else {
                                        el.removeAttribute('aria-current');
                                    }
                                });
        
                            } else {
                                entry.target.setAttribute('aria-hidden','true');
                            }
                            if( parseInt( entry.target.getAttribute('data-index') ) == 0 ) {
                                if( entry.isIntersecting ) {
                                    buttonPrev.setAttribute('disabled','true');
                                } else {
                                    buttonPrev.removeAttribute('disabled');
                                }
                            }
                            if( parseInt( entry.target.getAttribute('data-index') ) == ( boxs.length-1 ) ) {
                                if( entry.isIntersecting ) {
                                    buttonNext.setAttribute('disabled','true');
                                } else {
                                    buttonNext.removeAttribute('disabled');
                                }
                            }
                        } else {
                            boxs.forEach( ( box, index ) => {
                                box.removeAttribute('aria-hidden');
                            });
                        }
                    });
                },
                {
                    threshold : 0.5,
                }
            );
            boxs.forEach( ( el, index ) => {
                observerBox.observe( el );
            });
        // -- END -- //

        // -- mobile tile observer -- //
            if( window.innerWidth <= 1180 ) { // remove aria-hidden for mobile elements
                boxs.forEach( ( box, index ) => {
                    box.removeAttribute('aria-hidden');
                });
            }
            let observerTile = new IntersectionObserver(
                ( entries, settings ) => {
                    entries.forEach( ( entry, index ) => {

                        if( window.innerWidth <= 1180 ) {
                            if( parseInt( entry.target.getAttribute('data-index') ) == 0 ) {
                                if( entry.isIntersecting ) {
                                    buttonPrev.setAttribute('disabled','true');
                                } else {
                                    buttonPrev.removeAttribute('disabled');
                                }
                            }
                            if( parseInt( entry.target.getAttribute('data-index') ) == ( slides.length-1 ) ) {
                                if( entry.isIntersecting ) {
                                    buttonNext.setAttribute('disabled','true');
                                } else {
                                    buttonNext.removeAttribute('disabled');
                                }
                            }
                        }

                        if( entry.isIntersecting ) {
                            entry.target.querySelectorAll('a,button').forEach( el => {
                                el.removeAttribute('tabindex');
                            });
                        } else {
                            entry.target.querySelectorAll('a,button').forEach( el => {
                                if( window.innerWidth > 1180 ) {
                                    el.setAttribute('tabindex','-1');
                                } else {
                                    el.removeAttribute('tabindex');
                                }
                            });
                        }
                    });
                },
                {
                    threshold: 0.5,
                }
            );
            slides.forEach( ( el,index ) => {
                observerTile.observe( el );
            });
        // -- END -- //

        // -- horizontal image load -- //
            let observerLoad = new IntersectionObserver(
                ( entries, settings ) => {
                    entries.forEach( ( entry, index ) => {
                        if( entry.isIntersecting ) {
                            entry.target.querySelectorAll('.LazyAsset__item').forEach( ( image, index ) => {
                                window.theme.lazyObj.loadSingleImage( image );
                            });
                            observerLoad.unobserve( entry.target );
                        }
                    });
                },
                {
                    threshold: 0,
                    root : carouselWrapper,
                    rootMargin: '0px 200px',
                }
            );
            boxs.forEach( ( box, index ) => {
                observerLoad.observe( box );
            });
        // -- END -- //

        buttonNext.addEventListener('click', function() {
            if( buttonNext.hasAttribute('disabled') ) {
                return;
            }
            if( window.innerWidth > 1180 ) {
                carouselWrapper.scrollTo({ 
                    top: 0, 
                    left: carouselWrapper.scrollLeft + carouselWrapper.offsetWidth,
                    behavior: 'smooth' 
                });
            } else {
                carouselWrapper.scrollTo({ 
                    top: 0, 
                    left: carouselWrapper.scrollLeft + slides[0].offsetWidth,
                    behavior: 'smooth' 
                });
            }
        });
        buttonPrev.addEventListener('click', function() {
            if( buttonPrev.hasAttribute('disabled') ) {
                return;
            }
            if( window.innerWidth > 1180 ) {
                carouselWrapper.scrollTo({ 
                    top: 0, 
                    left: carouselWrapper.scrollLeft - carouselWrapper.offsetWidth,
                    behavior: 'smooth' 
                });
            } else {
                carouselWrapper.scrollTo({ 
                    top: 0, 
                    left: carouselWrapper.scrollLeft - slides[0].offsetWidth,
                    behavior: 'smooth' 
                });
            }
        });

        controls.forEach( ( button, index ) => {
            button.addEventListener('click', () => {
                carouselWrapper.scrollTo({ 
                    top: 0, 
                    left: carouselWrapper.offsetWidth * parseInt( button.getAttribute('data-index') ),
                    behavior: 'smooth' 
                });
            });
        });

    }
}
JSModules['EntriesArchiveSlider'] = EntriesArchiveSlider;
export default EntriesArchiveSlider;